import { Button } from '@codegouvfr/react-dsfr/Button';
import { ORGANISME_FORME_JURIDIQUE_TEXTS } from '@common/config';
import { OrganismeDetailsDto } from '@common/services';
import { getModalById } from '@common/ui';
import { Address, Place } from '@common/ui/etablissement';
import { EditOfaInfoModal } from '@common/ui/modal/organisme';
import { DateUtils } from '@common/utils';
import React, { ReactNode, useState } from 'react';
import { Panel } from '../base/Panel';
import { CheckedNda } from './CheckedNda';

const editInfoModal = getModalById('ofa-edit-info-modal');

export const OfaInfoPanel = ({ organisme, allEditable, isFc }: OfaInfoPanelProps) => {
  const [openExtra, setOpenExtra] = useState<boolean>(false);

  const contents: Content[] = [
    { title: 'Raison sociale', value: organisme.raisonSociale },
    { title: 'SIREN', value: organisme.siren },
    { title: 'NDA', value: <CheckedNda siren={organisme.siren} nda={organisme.nda} /> },
    { title: 'Effectif', value: organisme.effectifApprenti },
  ];

  const place: Place = {
    adresse: organisme.adresse,
    complementAdresse: organisme.complementAdresse,
    codePostal: organisme.codePostal,
    ville: organisme.ville,
  };

  const extraContents: Content[] = [
    { title: 'Dénomination usuelle', value: organisme.denominationUsuelle },
    { title: 'Forme juridique', value: ORGANISME_FORME_JURIDIQUE_TEXTS[organisme.formeJuridique] },
    { title: 'Adresse', value: <Address place={place} /> },
    { title: 'Hors-les-murs', value: organisme.horsLesMurs ? 'Oui' : 'Non' },
    {
      title: 'Début d\'activité apprentissage',
      value: DateUtils.formatDdMmYyyy(organisme.dateDebutActivite),
    },
    {
      title: 'Début de l\'exercice comptable',
      value: DateUtils.formatDdMmYyyy(organisme.dateDebutExerciceComptable),
    },
    {
      title: 'Fin de l\'exercice comptable',
      value: DateUtils.formatDdMmYyyy(organisme.dateFinExerciceComptable),
    },
    { title: '', value: '' }, // pour avoir le slot vide
    { title: 'Groupe', value: organisme.groupe },
    { title: 'Réseau', value: organisme.reseau },
  ];

  return (
    <Panel title="Informations"
           cornerButton={{ iconId: 'fr-icon-edit-fill', onClick: () => editInfoModal.open() }}>

      <div className={'flex flex-col gap-6'}>

        <div className={'mt-4 grid grid-cols-2 md:grid-cols-4 gap-4'}>
          {contents.map(({ title, value }, index) => (
            <div key={`${index}-${title}`} className={'flex flex-col gap-2'}>
              <span className={'color-primary'}>{title}</span>
              <span>{value}</span>
            </div>
          ))}
        </div>

        <div className={'separator'} />

        <Button priority={'tertiary no outline'} onClick={() => setOpenExtra(s => !s)}>
          {(openExtra) ? '- Afficher moins d\'informations' : '+ Afficher plus d\'informations'}
        </Button>

        {(openExtra) && (
          <div className={'mt-4 grid grid-cols-2 md:grid-cols-4 gap-4'}>
            {extraContents.map(({ title, value }, index) => (
              <div key={`${index}-${title}`} className={'flex flex-col gap-2'}>
                <span className={'color-primary'}>{title}</span>
                <span>{value}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <EditOfaInfoModal modal={editInfoModal}
                        organisme={organisme}
                        raisonSocialNdaReadonly={!allEditable}
                        isFc={isFc} />
    </Panel>
  );
};

interface OfaInfoPanelProps {
  organisme: OrganismeDetailsDto;
  allEditable?: boolean;
  isFc?: boolean;
}

interface Content {
  title: string;
  value: ReactNode;
}
